/**
 * 评估师管理
 */
import React from 'react';
import { Row, Col, Tooltip, Input, Button, Icon } from 'antd';
import PageLayout from '../../ui/PageLayout';
import http from '../../../axios/http';
import messager from '../../ui/messager';
import ValuationAssessorEdit from './ValuationAssessorEdit';
import { global_data } from '../../ui/auth'

class valuationAssessorIndex extends React.Component {

    columns = [{
        title: '证件号',
        dataIndex: 'creditNo',
        width: '10%',
    }, {
        title: '姓名',
        dataIndex: 'name',
        width: '10%',
    }, {
        title: '电话号码',
        dataIndex: 'tel',
        width: '10%',
    }, {
        title: '状态',
        dataIndex: 'state',
        width: '10%',
        format: { 0: '正常', 1: '删除', 2: '停用' }
    }, {
        title: '操作',
        dataIndex: 'id',
        width: '20%',
        render: (text, record, index) => (
            <div>
                {global_data.authCode.includes("VALUATION_ASSESSOR_UPDATE")?
                <Tooltip title="修改">
                    <Icon type="edit" theme="filled" className="table-operate-icon" onClick={this.update.bind(this, record)} />
                </Tooltip>
                :""}
                {global_data.authCode.includes("VALUATION_ASSESSOR_DELETE")?
                <Tooltip title="删除">
                    <Icon type="delete" theme="filled" className="table-operate-icon" onClick={this.operate.bind(this, text, "delete")} />
                </Tooltip>
                :""}
                {global_data.authCode.includes("VALUATION_ASSESSOR_ENABLE")?
                <Tooltip title="启用">
                    <Icon type="check-circle" theme="filled" className="table-operate-icon" onClick={this.operate.bind(this, text, "enable")} />
                </Tooltip>
                :""}
                {global_data.authCode.includes("VALUATION_ASSESSOR_DISABLE")?
                <Tooltip title="停用">
                    <Icon type="stop" theme="filled" className="table-operate-icon" onClick={this.operate.bind(this, text, "disable")} />
                </Tooltip>
                :""}
            </div>
        )
    }];

    state = {
        visible: false,
        editData: {},
        queryData: {}
    };


    inputSearch = (field, key) => {
        let queryData = this.state.queryData;
        queryData[field] = key;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    add = () => {
        this.setState({ visible: true, editData: {} });
    }

    update = (info) => {
        http.get({
            url: '/valuationAssessor/getOne',
            data: { id: info.id },
            success: (res) => {
                this.setState({ visible: true, editData: res });
            }
        });
    }

    operate = (id, state) => {
        let msgArr = {
            "enable": "启用",
            "delete": "删除",
            "disable": "停用",
        };
        let msg = msgArr[state];
        messager.confirm("是否" + msg + "该申请单？", () => {
            http.post({
                url: '/valuationAssessor/' + state,
                data: { id: id },
                success: (res) => {
                    this.state.loadData();
                    messager.notify(msg + "成功！");
                }
            });
        });
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={24}>
                                <Input.Search
                                    placeholder="姓名"
                                    onSearch={this.inputSearch.bind(this, "name")}
                                    enterButton
                                    style={{ width: '200px' }}
                                />
                                {global_data.authCode.includes("VALUATION_ASSESSOR_ADD")?
                                <Button type="primary" onClick={this.add} style={{ "float": "right" }}>新增</Button>
                                :""}
                            </Col>
                        </Row>
                    )}
                    rowKey="id"
                    url="/valuationAssessor/findAssessorPage"
                    requestType="get"
                    columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <ValuationAssessorEdit
                    visible={this.state.visible}
                    onCancel={() => this.setState({ visible: false })}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                />
            </div>
        )
    }
}

export default valuationAssessorIndex;